import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { DownIcon } from "../Icons/DownIcon";

@observer
export class AccordionButton extends Button {

	render() {
		return <Button {...this.props} >
			<DownIcon />
		</Button>;
	}
}
